module.exports = __webpack_public_path__ + "img/nexus-icon.3ce38f07.svg";